export default hashid => (
  window.open(`${process.env.API_LOCATION}/credit_note/${hashid}/pdf/download/?token=${localStorage.getItem('id_token')}`)
);



// WEBPACK FOOTER //
// ./src/app/services/creditNote/download.js